// Start FAQ Accordion
const faqQuestions = document.querySelectorAll('.faq__question');
const faqRows = document.querySelectorAll('.faq__row');

faqQuestions.forEach(question => {
  question.addEventListener('click', function() {
    const thisRow = question.closest('.faq__row');
    const answerContainer = thisRow.querySelector('.faq__answer');
    const answerHeight = getComputedStyle(answerContainer.querySelector('.faq__answer-content')).height;

    // 1) Active class
    if (thisRow.classList.contains('active')) {
      thisRow.classList.remove('active');
    } else {
      faqRows.forEach(el => el.classList.remove('active'));
      thisRow.classList.add('active');
    }

    // 2) Answer Animation
    if (thisRow.classList.contains('active')) {
      // Close all answers
      faqRows.forEach(el => el.querySelector('.faq__answer').style.maxHeight = 0);
      // Open this answer
      answerContainer.style.maxHeight = answerHeight;
    } else {
      // Close this answer
      answerContainer.style.maxHeight = 0;
    }
  })
})

// Adjusct Answer Height on Resize
window.addEventListener('resize', function() {
  faqQuestions.forEach(question => {
    const thisRow = question.closest('.faq__row');
    const answerContainer = thisRow.querySelector('.faq__answer');
    const answerHeight = getComputedStyle(answerContainer.querySelector('.faq__answer-content')).height;

    if (thisRow.classList.contains('active')) answerContainer.style.maxHeight = answerHeight;
  })
})